import { Drawer } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { useTranslation } from 'react-i18next';
import { ParcelBaseTable } from './ParcelBaseTable';

export const ParcelBaseSelect = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const visible = useAppSelector(
    (state) => state.parcel.baseSelectState.visible
  );
  const onClose = () => {
    dispatch.parcel.updateBaseSelectVisible(false);
  };

  return (
    <Drawer
      title={t('platform.parcel.createParcelFromBase')}
      placement="right"
      width={800}
      bodyStyle={{ paddingTop: 0 }}
      closable={true}
      onClose={onClose}
      visible={visible}
    >
      <ParcelBaseTable />
    </Drawer>
  );
};
